import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgMagicLinkIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M200 0c18.262 21.201 38.404 40.89 60.185 58.84-14.513 44.619-22.327 92.025-22.327 141.16 0 49.135 7.814 96.541 22.327 141.161C238.404 359.109 218.262 378.799 200 400c-18.262-21.201-38.404-40.891-60.185-58.839 14.513-44.62 22.327-92.026 22.327-141.161 0-49.135-7.814-96.541-22.327-141.16C161.596 40.89 181.738 21.2 200 0ZM98.183 310.312A511.594 511.594 0 0 0 25 269.911c7.118-22.114 10.947-45.589 10.947-69.911 0-24.322-3.83-47.796-10.947-69.911a511.651 511.651 0 0 0 73.183-40.4c8.816 35.413 13.481 72.345 13.481 110.311 0 37.966-4.665 74.898-13.481 110.312ZM288.336 200c0 37.966 4.665 74.898 13.481 110.312A511.583 511.583 0 0 1 375 269.911c-7.118-22.114-10.947-45.589-10.947-69.911 0-24.322 3.829-47.796 10.947-69.911a511.62 511.62 0 0 1-73.183-40.4c-8.816 35.413-13.481 72.345-13.481 110.311Z"
      fill="#6851FF"
    />
  </svg>
);

export default SvgMagicLinkIcon;
